import TilesTemplate from './TilesTemplate'

export * from './TilesTemplate'

export default TilesTemplate
